export default function formatPhoneNumber(value) {
  if (value) {
    const phone = value.replace(/\D/g, '');
    if (phone.length === 12) {
      const match = phone.match(/^(\d{2})(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return (
          '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4]
        );
      }
    } else if (phone.length === 11) {
      const match = phone.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return (
          '+' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4]
        );
      }
    } else {
      const match = phone.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
    }
  }
  return '';
}
